var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('h1',[_vm._v("视频分片加载")]),(_vm.videoUrl)?_c('video',{ref:"video",attrs:{"controls":""},on:{"play":_vm.handlePlay,"pause":_vm.handlePause}},[_c('source',{attrs:{"src":_vm.videoUrl,"type":"video/mp4"}}),_vm._v(" 您的浏览器不支持视频播放。 ")]):_c('div',[_vm._v("加载中...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }